import { Flame, Share2 } from "lucide-react";
import { renderMarkdown } from "@/lib/renderMarkdown";
import { FAITHS } from "@/lib/faiths";

export const AnswerView = ({ entry, onShare, index }) => {
  const faithLabel = FAITHS.find((f) => f.id === entry.faith)?.label || "All Faiths";
  const isStreaming = entry.status === "streaming";
  const html = renderMarkdown(entry.answer || "");

  return (
    <article
      data-testid={`ai-answer-container${index === 0 ? "" : `-${index}`}`}
      className="rounded-2xl bg-[#5C0E1D] gold-border p-6 sm:p-8 fade-up"
    >
      {/* Question echo */}
      <div className="mb-5 pb-5 border-b border-[#E7B04A]/25">
        <div className="text-xs sm:text-[0.75rem] uppercase tracking-[0.16em] text-[#FBEBD3] font-sans-clean font-bold mb-1">
          You asked · {faithLabel}
        </div>
        <p className="font-serif-display text-3xl sm:text-2xl text-[#FFFFFF] leading-snug font-medium">
          {entry.question}
        </p>
      </div>

      {isStreaming && !entry.answer && (
        <div className="flex items-center gap-3 text-[#FBEBD3] italic font-scripture">
          <Flame className="w-4 h-4 text-[#E7B04A] flicker" />
          <span className="shimmer-text">Listening to the scriptures…</span>
        </div>
      )}

      <div
        className="answer-md"
        dangerouslySetInnerHTML={{ __html: html }}
      />

      {!isStreaming && entry.answer && (
        <div className="mt-6 pt-5 border-t border-[#E7B04A]/25 flex items-center justify-end">
          <button
            data-testid={`share-answer-card-btn${index === 0 ? "" : `-${index}`}`}
            onClick={() => onShare(entry)}
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-[#FBEBD3] hover:text-[#E7B04A] transition-colors"
          >
            <Share2 className="w-3.5 h-3.5" strokeWidth={1.6} />
            Share this answer
          </button>
        </div>
      )}

      {entry.error && (
        <div className="mt-4 text-sm text-[#E7B04A] italic font-scripture">
          The candle flickered out: {entry.error}
        </div>
      )}
    </article>
  );
};

export default AnswerView;
